import React from 'react'
import { Link } from 'react-router-dom'

function Columbss() {
    return (
        <div>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/Multideck" className="block py-1 pl-4 hover:underline mt-6">Multideck -</Link>
           <span className="block py-1 pl-4 mt-6">Columbs</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/columbsnew.jpg" alt="Vista" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">Columbs</h1>
           <p className="text-xl lg:text-2xl font-thin max-w-sm mx-auto text-gray-500">High capacity and visibility of your products.</p>
           <p className="text-xl lg:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">COLUMBUS is a line of multidecks with remote condensing unit designed to meet efficiently the different needs of your business. The rear service cabinets are available in two depths, 98 cm and 65 cm, and allow you to quickly and easily display and serve your cheese & charcuterie products to your Customers.</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>
    
    <div className="grid grid-cols-1 gap-4 text-center mb-6">
       
       <p className="text-xl lg:text-2xl opacity-90">CHARCUTERIE & CHEESE <span className=' text-blue-400'>-1… +4 °C</span> (3M1)</p>
    </div>

         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
           <p className="text-xl lg:text-2xl text-lime-500 text-center mt-3">CO2 | R290</p>
         </div>
    
    
    
         {/* ✅ Case Images & Features */}
         <div className="flex flex-col gap-8 ">
            {/* case 1 */}
             <div 
               className="flex flex-col  pb-16 md:mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
                {/* ✅ Image Wrapper */}
                <div className="w-full md:w-1/2">
                 <img src="/images/columbsnew1.gif" className="max-w-full h-auto object-contain" />
               </div>
               <div className="w-full md:w-1/2 px-4">
    <p className="text-2xl">Your ally for Ham, Cheese and Sausages !</p>
<ul className="list-[square] list-outside text-gray-500">
  <li className="text-xl  font-thin opacity-90 mt-6">
  <span className='text-gray-600 font-semibold'> Fan assisted cooling with air curtain</span> for an even temperature.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
  Available in two display depths<span className='text-gray-600 font-semibold'> 98 cm and 65 cm.</span> 
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
  Cooled storage for a quick stock refill.
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
  Sliding glass front doors, which allow<span className='text-gray-600 font-semibold'>  energy savings of up to 50%</span> (optional).
  </li>
  <li className="text-xl  font-thin opacity-90 mt-6">
  <span  className='text-gray-600 font-semibold'> LED lightning</span> of high brightness and high energy efficiency.
  </li>
</ul>
</div>
             </div>
         </div>
     </div>
    
  
        </div>
      )
    }


export default Columbss